module.exports = __webpack_public_path__ + "img/ms_my.b8c75e82.png";